import { render, staticRenderFns } from "./phoneLabel.vue?vue&type=template&id=3aa1aeba&scoped=true&"
import script from "./phoneLabel.vue?vue&type=script&lang=ts&"
export * from "./phoneLabel.vue?vue&type=script&lang=ts&"
import style0 from "./phoneLabel.vue?vue&type=style&index=0&id=3aa1aeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa1aeba",
  null
  
)

export default component.exports